import Repository from './Repository';

class RoleRepository extends Repository {
	getRoles () {
		return this.getWithToken('/roles');
	}

	getPermissions () {
		return this.getWithToken('/roles/permissions');
	}

	createRole (form) {
		return this.postWithToken('/roles', form);
	}

	editRole (form) {
		return this.putWithToken(`/roles/${form.id}`, form);
	}

	deleteRole (roleId) {
		return this.deleteWithToken(`/roles/${roleId}`);
	}
}

export default new RoleRepository();
